import React from "react";
import OfflinePage from "./OfflinePage";
type Props = {
  children: React.ReactNode;
};

const DetectConnectionComponent = ({ children }: Props) => {
  const [status, setStatus] = React.useState(() => {
    if (navigator.onLine) {
      console.log("Connected to network.");
      return true;
    } else {
      return false;
    }
  });
  React.useEffect(() => {
    window.addEventListener("offline", function (_) {
      setStatus(false);
      console.log("offline");
    });

    window.addEventListener("online", function (_) {
      setStatus(true);
      console.log("online");
    });
  }, [status]);
  return <>{status ? children : <OfflinePage />}</>;
};

export default DetectConnectionComponent;
